import type { NodeSn } from '@ipfabric/utils';
import type { PathLookupPathInspectorHighlightedEdges } from 'components/Graph/GraphState';

export const getNodeHighlightedEdges = (
  nodeSn: NodeSn | null,
  highlightedEdges: PathLookupPathInspectorHighlightedEdges,
) => {
  // Check if there's a node and if its corresponding highlighted edges exist
  if (nodeSn !== null && highlightedEdges[nodeSn] !== undefined) {
    return highlightedEdges[nodeSn];
  }
  return undefined;
};
